import { render, staticRenderFns } from "./bankInformation.vue?vue&type=template&id=a6bb8340&"
import script from "./bankInformation.vue?vue&type=script&lang=js&"
export * from "./bankInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports